import { toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { API_URL } from '../utils/utils.js'
// import { RootColorTheme } from "../css/rootColorTheme";

const getData = async (route, params = {}) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`;

    const queryParams = new URLSearchParams(params).toString();
    const sessionToken = sessionStorage.getItem("sessionToken"); // Get stored token
    console.log("🔑 Session Token in getData:", sessionToken);
    const response = await fetch(`${URL_ROUTE}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionToken}` // Include token for authentication
      }
    });

    // if (response.status === 401) {
    //   toast.error("Session timed out. Please login to continue.");
    //   window.location.href = '/login';
    //   return;
    // }

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    return await response.json();
  } catch (e) {
    console.error("API Error:", e);
    throw e;
  }
};


const postData = async (route, data, sessionToken = null, isFormData = false) => {
  try {
    if (!API_URL) {
      throw new Error("❌ API_URL is not defined. Please check your environment config.");
    }
    if (!route) {
      throw new Error("❌ Route is required for postData.");
    }

    // Ensure no accidental double slashes (and preserve "/")
    const URL_ROUTE = `${API_URL.replace(/\/+$/, "")}/${route.replace(/^\/+/, "")}`;

    // ✅ Set headers conditionally
    const headers = {};
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }
    if (sessionToken) {
      headers["Authorization"] = `Bearer ${sessionToken}`;
    }

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      headers,
      body: isFormData ? data : JSON.stringify(data),
    });

    console.log("Response URL:", URL_ROUTE);
    console.log("Response Status:", response.status);

    // ✅ Safely parse JSON only if response is JSON
    const contentType = response.headers.get("content-type");
    let responseData;

    if (contentType && contentType.includes("application/json")) {
      responseData = await response.json();
    } else {
      const text = await response.text();
      console.error("Non-JSON response:", text);
      throw new Error(`Expected JSON, but got: ${text.substring(0, 100)}...`);
    }

    if (!response.ok) {
      console.error("Response Error:", responseData);
      throw new Error(responseData.message || `Error: ${response.status}`);
    }

    console.log("Response Data:", responseData);
    return responseData;
  } catch (e) {
    console.error("Unexpected Error:", e.message);
    throw e;
  }
};

const postDataBulkUpload = async (route, data, sessionToken) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`.replace(/\/+$/, "");

    console.log("Sending Request to:", URL_ROUTE);
    console.log("Request Body:", data);

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        Authorization: `Bearer ${sessionToken}`,

      },
      body: data,
    });

    if (response.status === 401) {
      toast.error("Session timed out. Please login to continue.");
      window.location.href = '/login';
      return;
    }

    console.log("Response Status:", response.status);

    const responseData = await response.json(); // Parse JSON once

    if (!response.ok) {
      console.error("Response Error:", responseData);
      throw new Error(responseData.message || `Error: ${response.status}`);
    }

    console.log("Response Data:", responseData);
    return responseData;
  } catch (e) {
    console.error("Unexpected Error:", e.message);
    throw e;
  }
};

const patchData = async (route, body = {}) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`;
    const sessionToken = sessionStorage.getItem("sessionToken"); // Get stored token

    const response = await fetch(URL_ROUTE, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionToken}` // Include token for authentication
      },
      body: JSON.stringify(body) // Send the patch data
    });

    if (response.status === 401) {
      alert("Session timed out. Please login to continue.");
      window.location.href = '/login';
      return;
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    return await response.json();
  } catch (e) {
    console.error("API Error:", e);
    throw e;
  }
};


const putData = async (route, data, sessionToken = null) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`.replace(/\/+$/, "");

    console.log("Sending PUT Request to:", URL_ROUTE);
    console.log("Request Body:", JSON.stringify(data));
    const headers = {
      'Content-Type': 'application/json',
    };

    if (sessionToken) {
      headers['Authorization'] = `Bearer ${sessionToken}`;
    }

    const response = await fetch(URL_ROUTE, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
    });

    // if (response.status === 401) {
    //   toast.error("Session timed out. Please login to continue.");
    //   window.location.href = '/login';
    //   return;
    // }

    console.log("Response Status:", response.status);

    const responseData = await response.json(); // Parse JSON once

    if (!response.ok) {
      console.error("Response Error:", responseData);
      throw new Error(responseData.message || `Error: ${response.status}`);
    }

    console.log("Response Data:", responseData);
    return responseData;
  } catch (e) {
    console.error("Unexpected Error:", e.message);
    throw e;
  }
};

const deleteData = async (route, sessionToken) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`.replace(/\/+$/, "");

    console.log("Sending DELETE Request to:", URL_ROUTE);

    const response = await fetch(URL_ROUTE, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${sessionToken}`,
      },
    });

    // if (response.status === 401) {
    //   toast.error("Session timed out. Please login to continue.");
    //   window.location.href = '/login';
    //   return;
    // }

    console.log("Response Status:", response.status);

    if (!response.ok) {
      const responseData = await response.json();
      console.error("Response Error:", responseData);
      throw new Error(responseData.message || `Error: ${response.status}`);
    }

    console.log("User deleted successfully!");
    return { success: true, message: "Deleted successfully" };
  } catch (e) {
    console.error("Unexpected Error:", e.message);
    throw e;
  }
};

const uploadFile = async (userId, file) => {
  const URL_ROUTE = `${API_URL}${userId}`;
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await fetch(URL_ROUTE, {
      method: "POST",
      body: formData,
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("File Upload Error:", error);
    return { success: false, message: "Error uploading file" };
  }
};


export { getData, postData, putData, deleteData, uploadFile, postDataBulkUpload, patchData };
